import services from '@/services';
const MANAGEMENT_PATH = '/management';
const CLASSES_PATH = '/classes';
const error = function (err) {
    console.log(err);
    throw new Error('Error to save');
}
export default {
    getEntityItemById: async function (entity, id, token) {
        try {
            return await services.get(`${MANAGEMENT_PATH}/entities/${entity}/${id}`, null, { token });
        } catch (err) {
            error(err);
        }
    },
    deleteDrug: async function ({ id, category, tempExclusion, productExclusion }, token) {
        try {
            await services.post(`${MANAGEMENT_PATH}/summaries-exclusion`, {
                id, category, tempExclusion, productExclusion
            }, null, { token });
        } catch (err) {
            error(err);
        }
    },
    loginManagement: async (user, password) => {
        const headers = { user: user, password: password };
        return await services.post(`${MANAGEMENT_PATH}/login`, null, null, headers);
    },
    insertPhoto: async (name, type, file, path, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/temporaries/photos`, {
                name,
                base64FileExtension: type,
                file,
                path
            }, null, { token });
        } catch (err) {
            error(err);
        }
    },
    saveItemAndProducts: async (document, token) => {
        try {
            await services.post(`${MANAGEMENT_PATH}/temporaries`, document, null, { token });
        } catch (err) {
            error(err);
        }
    },
    changeItemStatus: async (id, available, token) => {
        try {
            const path = `${MANAGEMENT_PATH}/topics/subtopics/items/${id}/approvals`;
            return await services.post(path, { available }, null, { token });
        } catch (err) {
            error(err);
        }
    },
    changeSubtopicStatus: async (id, available, token) => {
        try {
            const path = `${MANAGEMENT_PATH}/topics/subtopics/${id}/approvals`;
            return await services.post(path, { available }, null, { token });
        } catch (err) {
            error(err);
        }
    },
    addTopic: async (topic, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/topics`, topic, null, { token });
        } catch (err) {
            error(err);
        }
    },
    addSubtopic: async (subtopic, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/topics/subtopics`, subtopic, null, { token });
        } catch (err) {
            error(err);
        }
    },
    getSubtopic: async (id, token) => {
        try {
            return await services.get(`${MANAGEMENT_PATH}/topics/subtopics/${id}`, null, { token });
        } catch (err) {
            error(err);
        }
    },
    addItem: async ({ name, subtopic }, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/topics/subtopics/${subtopic.id}/items`, { name }, null, { token });
        } catch (err) {
            error(err);
        }
    },
    getItem: async (id, token) => {
        try {
            return await services.get(`${MANAGEMENT_PATH}/topics/subtopics/items/${id}`, null, { token });
        } catch (err) {
            error(err);
        }
    },
    saveItemChanges: async (id, body, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/topics/subtopics/items/${id}`, body, null, { token });
        } catch (err) {
            error(err);
        }
    },

    getCustomers: async (userAppUid, token) => {
        try {
            return await services.get(`${MANAGEMENT_PATH}/customers?uid=${userAppUid}`, null, { token });
        } catch (err) {
            error(err);
        }
    },

    getCustomerWithUid: async (uid, token) => {
        try {
            return await services.get(`${MANAGEMENT_PATH}/customers/${uid}`, null, { token });
        } catch (err) {
            error(err);
        }
    },

    saveCustomerSettings: async (uid, customer, token) => {
        try {
            return await services.post(`${MANAGEMENT_PATH}/customers/${uid}`, customer, null, { token });
        } catch (err) {
            error(err);
        }
    },

    async postClasses(classes, token) {
        try {
            await services.post(MANAGEMENT_PATH + CLASSES_PATH, classes, null, { token });
        } catch (err) {
            console.log(err);
            throw new Error('Error to save');
        }
    },
    async getClasses(token) {
        try {
            return await services.get(MANAGEMENT_PATH + CLASSES_PATH, null, { token });
        } catch (err) {
            console.log(err);
            throw new Error('Error to save');
        }
    }
}